import { render, staticRenderFns } from "./TestimonialsView.vue?vue&type=template&id=7cd19996&scoped=true&"
import script from "./TestimonialsView.vue?vue&type=script&lang=js&"
export * from "./TestimonialsView.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsView.vue?vue&type=style&index=0&id=7cd19996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd19996",
  null
  
)

export default component.exports